import React from "react";
import classnames from "classnames";
import { FmIcon } from "../FmIcon";
import { useTheme } from "../../Hooks";
import { APP_NAME, LOGGED_IN_ROUTES } from "../../Constants";
import { FmText } from "../FmText";
import { FmTextButton } from "../FmTextButton";
import { FmIconButton } from "../FmIconButton";
import useStyles from "./FmMobileHeader.style";
import { useSelector } from "react-redux";
import { GeneralState } from "../../Redux";
import { useHistory } from "react-router-dom";

export declare type LeftIconStyle = "backArrow" | "hamburger";

interface FmMobileHeaderProps {
  addShadow?: boolean;
  rightButtonText?: string;
  rightButtonOnClick?: () => void;
  leftIconStyle?: LeftIconStyle;
  onLeftButtonClick?: () => void;
  className?: string;
}

const FmMobileHeader = ({
  rightButtonText,
  rightButtonOnClick,
  leftIconStyle,
  onLeftButtonClick,
  addShadow = false,
  className,
}: FmMobileHeaderProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const containerClass = classnames(classes.container, className, {
    [classes.shadow]: addShadow,
  });

  const leftButtonClass = classnames({
    [classes.leftButton]: theme.direction !== "rtl",
    [classes.rightButton]: theme.direction === "rtl",
  });

  const agriIsMainInterest = useSelector(GeneralState.Selectors.selectAgriIsMainInterestOfUser);

  const defaultPath = agriIsMainInterest ? LOGGED_IN_ROUTES.AGRI_SOLUTION : LOGGED_IN_ROUTES.SOLUTION;

  const logoClickHandler = () => {
    history.push(defaultPath);
  };
  return (
    <div className={containerClass}>
      <div className={classes.leftSide}>
        {leftIconStyle && <FmIconButton className={leftButtonClass} variant={leftIconStyle} onClick={onLeftButtonClick} />}
      </div>
      <div className={classes.center} onClick={logoClickHandler}>
        <FmIcon url={theme.images.smallLogo} title={APP_NAME} className={classes.icon} />
        <FmText variant={"headerTitle"}>{APP_NAME}</FmText>
      </div>
      <div className={classes.rightSide}>
        {rightButtonText && (
          <FmTextButton className={classes.textBtn} onClick={rightButtonOnClick}>
            <FmText variant={"light"}>{rightButtonText || ""}</FmText>
          </FmTextButton>
        )}
      </div>
    </div>
  );
};

export default FmMobileHeader;
